const FileViewer = ({ file }: any) => {
  const isPDF = file.endsWith(".pdf");
  const filteredUrl = `${file}#toolbar=0&page=1`;

  return (
    <div className="h-[210px] w-full rounded-t-lg relative overflow-hidden">
      {isPDF ? (
        <object
          data={filteredUrl}
          type="application/pdf"
          className="w-full h-full"
          style={{
            border: "none",
            pointerEvents: "none",
            overflow: "hidden",
            height: "120px",
            maxHeight: "120px",
            width: "100%",
          }}
        >
          <p></p>
        </object>
      ) : (
        <img
          src={file}
          alt="فایل آزمایش"
          className="h-auto w-full object-cover"
        />
      )}
    </div>
  );
};

export default FileViewer;
